import * as logger from '../logging/logger';

interface AccessToken {
    instance: number;
    value: string | null;
}

let _AccessToken = {} as AccessToken;
_AccessToken = {
    instance: 0,
    value: null
};

export default async function getAccessToken(
    clientId: string,
    clientSecret: string,
    scope: string,
    tokenUrl: string = '/api/connect/token'
): Promise<string | null> {
    return _AccessToken.value || (await init(clientId, clientSecret, scope, tokenUrl));
}

async function init(client_id: string, client_secret: string, scope: string, tokenUrl: string): Promise<string | null> {
    const token = {
        client_id,
        client_secret,
        grant_type: 'client_credentials',
        expires_in: 1200000,
        token_type: 'Bearer',
        scope
    };
    let requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
            (({ grant_type, client_id, scope, client_secret }) => ({
                grant_type,
                client_id,
                scope,
                client_secret
            }))(token)
        ).toString()
    };
    try {
        const response = await fetch(tokenUrl, requestOptions);
        /* istanbul ignore else */
        if (response.ok) {
            _AccessToken.instance++;
            const json = await response.json();
            _AccessToken.value = json.access_token;
            if (_AccessToken.instance === 1)
                setInterval(async () => init(token.client_id, token.client_secret, token.scope, tokenUrl), (json.expires_in - 30) * 1000);
        } else {
            logger.log('Error', `Bearer Token : Status: ${response.status}, ${response.statusText}`);
        }
    } catch (e) {
        logger.log('Error', `Bearer Token : ${e.message}`);
    }
    return _AccessToken.value;
}

export { getAccessToken as initAccessToken };
